import { makeRequest } from "./makeRequest";

// Define a function to handle API requests with error handling and retries
async function handleRequest(url, headers, retries = 3) {
  try {
    const response = await makeRequest(url, { headers });
    return response;
  } catch (error) {
    console.error(`Error: ${error.message}`);
    if (retries > 0) {
      console.log(`Retrying... (remaining retries: ${retries})`);
      return handleRequest(url, headers, retries - 1);
    } else {
      throw new Error("Max retries reached, unable to fetch data.");
    }
  }
}

export function getPosts() {
  return handleRequest("/posts", { Accept: "application/json" });
}

export function getComments() {
  return handleRequest("/comments", { Accept: "application/json" });
}

export async function  getreportsList(passtoken,) {
  const headers = {
    "oidc-token": passtoken,
    Accept: "application/json",
  };
  // return handleRequest("/aipd/overview", headers);
  return handleRequest(`/aipd/getOverview`, headers);

}

export async function getreportsVisuals(id, passtoken) {
  const headers = {
    "oidc-token": passtoken,
    Accept: "application/json",
  };
  return handleRequest(`/aipd/reports/${id}`, headers);
}

export async function getpbireports(id, passtoken) {
  const headers = {
    "oidc-token": passtoken,
    Accept: "application/json",
  };
  return handleRequest(`/aipd/reports/${id}`, headers);
}

export async function getUserRole(email, passtoken) {
  const headers = {
    "oidc-token": passtoken,
    Accept: "application/json",
  };
  return handleRequest(`/aipd/userListByEmail`, headers);
}

export async function getAllUser(passtoken) {
  const headers = {
    "oidc-token": passtoken,
    Accept: "application/json",
  };
  return handleRequest("/aipd/users", headers);
}

export async function getAnalytics(passtoken) {
  const headers = {
    "oidc-token": passtoken,
    Accept: "application/json",
  };
  return handleRequest("/aipd/completeTracking", headers);
}

export async function getPersonaManagement(passtoken) {
  const headers = {
    "oidc-token": passtoken,
    Accept: "application/json",
  };
  return handleRequest(
    "/aipd/persona-administration/persona-management",
    headers
  );
}

export async function getRoleManagement(passtoken) {
  const headers = {
    "oidc-token": passtoken,
    Accept: "application/json",
  };
  return handleRequest("/aipd/role-management/roles", headers);
}

export function getSubComments() {
  return handleRequest("/subcomments", { Accept: "application/json" });
}
